import { Box, Typography } from '@mui/material'
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutlineOutlined'
import ErrorOutline from '@mui/icons-material/ErrorOutlineOutlined'

import { formatSlaTime } from './slaTime'

interface SlaCountdownPillProps {
  earliestCompletionSlaAt: string | null | undefined
  earliestCompletionSlaTaskType: 'urgent' | 'normal' | null | undefined
  messageCount: number
  onClick?: () => void
}

type PillVariant = 'urgent' | 'normal' | 'default'

const PILL_STYLES: Record<PillVariant, { backgroundColor: string; color: string }> = {
  urgent: { backgroundColor: '#FFE6E5', color: '#B71C1C' },
  normal: { backgroundColor: '#E5F3FD', color: '#0D47A1' },
  default: { backgroundColor: '#F5F5F5', color: '#293E51' },
}

const SlaCountdownPill = ({
  earliestCompletionSlaAt,
  earliestCompletionSlaTaskType,
  messageCount,
  onClick,
}: SlaCountdownPillProps) => {
  const slaText = earliestCompletionSlaAt ? formatSlaTime(earliestCompletionSlaAt) : null
  const pillVariant: PillVariant = earliestCompletionSlaTaskType ?? 'default'

  return (
    <Box
      onClick={onClick}
      data-testid="sla-countdown-pill"
      sx={{
        mt: 1,
        mb: -2,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1.5,
        py: 0.75,
        borderRadius: '50px',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              opacity: 0.85,
            }
          : {},
        ...PILL_STYLES[pillVariant],
      }}
    >
      <ChatBubbleOutline sx={{ fontSize: 16 }} />
      <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1 }}>
        {messageCount}
      </Typography>
      {slaText && (
        <>
          <Typography variant="caption" sx={{ mx: 0.25 }}>
            ·
          </Typography>
          <ErrorOutline sx={{ fontSize: 16 }} />
          <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1 }}>
            {slaText}
          </Typography>
        </>
      )}
    </Box>
  )
}

export default SlaCountdownPill
